/* eslint-disable */

import PropTypes from "prop-types";
import React from "react";
import Select from "react-dropdown-select";

export function Search(props: any) {
  /**
   *
   * @param values Searched object
   * @returns searched object back to parent component
   */
  const searchedResult = (values: object) => {
    if (values) {
      return props.handleSearchResult(values);
    }
  };
  return (
    <>
      <Select
        className="search_select_box"
        style={{
          position: "relative",
        }}
        placeholder="Search..."
        dropdownPosition="bottom"
        dropdownGap={1}
        options={props.options}
        valueField={
          "WISE Objects"
        }
        sortBy={
          "WISE Objects"
        }
        labelField={
          "WISE Objects"
        }
        values={[]}
        onChange={(values) => {
          searchedResult(values);
        }}
      />
    </>
  );
}

Search.prototype = {
  options: PropTypes.any,
  handleSearchResult: PropTypes.func,
};

export default Search;
